export const SITE = {
    name: 'Klinik Pergigian Irma Ariandi',
    tagline: 'WEAR YOUR SMILE',
    promise: ['Good dentistry.', 'Honest advice.', 'Transparent fees.', 'Human care.'],
    domain: 'iinspire.my/dental',
    url: 'https://iinspire.my/dental',
    whatsappDisplay: '011-3306 5735',
    whatsappIntl: '601133065735',
    email: 'klinikpergigianirmaariandi@gmail.com',
    address: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
    addressShort: 'Johor Bahru, Johor, Malaysia',
    location: 'Johor Bahru, Johor, Malaysia',
};

export const waLink = (msg) =>
    `https://wa.me/${SITE.whatsappIntl}${msg ? `?text=${encodeURIComponent(msg)}` : ''}`;

export const mailLink = (subject) =>
    `mailto:${SITE.email}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`;

export const DEFAULT_KOLUM_COVER = '/img/articles/default-dental-cover.png';

export const SITE_URL = SITE.url;

export const doctorDisplayName = (name) =>
    name === 'Dr. Irma Ariandi' ? 'Dr. Irma (DDS, UKM)' : name === 'Dr. Ariandi' ? 'Dr. Ariandi (DDS, UKM)' : name;
